import { IExtractList } from "../../../LeftPanel/ExtractList/redux/Types";

// To click the dashboard tab
export const setActiveTab = (isToSetCurrentReport?: boolean): void => {
  const tabButton = isToSetCurrentReport ?
    document.querySelectorAll(".eui-dynamic-tabs__list-item--active button")[0] as HTMLElement
    :
    document.querySelectorAll(".eui-dynamic-tabs__section li button")[0] as HTMLElement;
  if (tabButton)
    tabButton.click();
};

// To close previously opened all other tabs
export const closeOtherReportTabs = (): void => {
  const availableTabs = document.querySelectorAll(".eui-dynamic-tabs__list-item");
  availableTabs.forEach((element: HTMLElement, index: number) => {
    if (index > 1) {
      element.style.setProperty("display", "none");
    }
  });
};

/**
* To return the filtered list based on available search input text
* @param searchInput search input text
* @param extractList available extract list for the selected financial year
* @returns the extract list based on search input text
*/
export const getExtractListBasedOnSearchInput = (searchInput: string,
  extractList: IExtractList[]): IExtractList[] => {
  const searchtext = searchInput.trim().toLowerCase();
  if (searchInput.length > 0 && extractList.length > 0) {
    return extractList.filter((item: IExtractList): boolean => {
      const extractname = item.extractName.toString().toLowerCase();
      return extractname.includes(searchtext);
    });
  }
  else {
    return extractList;
  }
};
